export default __webpack_public_path__ + "static/suz-hinton-3d77cd916bb7b8982c7674a3df89bcdc.jpg";